import setup from './core/setup'
import Events from './core/events'

export default {
  setup,
  Events
}
